import TeacherSelectorV2 from './src/main';

/* istanbul ignore next */
TeacherSelectorV2.install = function(Vue) {
  Vue.component(TeacherSelectorV2.name, TeacherSelectorV2);
};

export default TeacherSelectorV2;
